<template>
  <div class="app-container">
    <div v-if="showHelpModal" class="modal-overlay" @click.self="showHelpModal = false">
  <div class="help-modal">
    <div class="modal-header">
      <h2>🚀 Uygulama Kullanım Kılavuzu</h2>
      <button @click="showHelpModal = false" class="close-btn">✕</button>
    </div>
    <div class="modal-content">
      <div class="guide-item">
        <span class="guide-number">1</span>
        <p><strong>XML ve Şablon Yükleme:</strong> Önce XML dosyanızı yükleyin, ardından "Hızlı Şablonlar" menüsünden bir tasarım seçin.</p>
      </div>
      <div class="guide-item">
        <span class="guide-number">2</span>
        <p><strong>Metin Düzenleme:</strong> Fatura üzerindeki herhangi bir metni değiştirmek için o metne <strong>çift tıklayın.</strong></p>
      </div>
      <div class="guide-item">
        <span class="guide-number">3</span>
        <p><strong>Notlar Alanı:</strong> Faturadaki notlar/banka bilgileri alanına bir kez tıklayarak gelişmiş editörü (TinyMCE) açabilirsiniz.</p>
      </div>
      <div class="guide-item">
        <span class="guide-number">4</span>
        <p><strong>Logo ve Renk:</strong> Logonuzu yükleyebilir, çerçeve ve gölge ekleyebilirsiniz. Renk paletinden faturanın ana temasını değiştirebilirsiniz.</p>
      </div>
      <div class="guide-item">
        <span class="guide-number">5</span>
        <p><strong>XSLT İndir:</strong> Düzenlemeleriniz bittiğinde "XSLT İndir" butonu ile çıktı alıp fatura kesme programınızda kullanabilirsiniz.</p>
      </div>
    </div>
    <div v-if="infoModalActive" class="modal-overlay" @click.self="infoModalActive = false">
  <div class="help-modal"> <div class="modal-header">
      <h2 v-if="infoModalType === 'about'">ℹ️ Hakkımızda</h2>
      <h2 v-if="infoModalType === 'privacy'">🛡️ XSLT Nedir?</h2>
      <h2 v-if="infoModalType === 'contact'">📞 İletişim</h2>
      <button @click="infoModalActive = false" class="close-btn">✕</button>
    </div>
    
    <div class="modal-content" style="line-height: 1.8; color: #475569;">
      
      <div v-if="infoModalType === 'about'">
        <p><strong>E-Fatura Tasarım Aracı</strong>, işletmelerin teknik XSLT kodlarıyla uğraşmadan, görsel bir arayüz üzerinden kendi fatura şablonlarını oluşturabilmesi için geliştirilmiştir.</p>
        <p>2026 e-dönüşüm standartlarına tam uyumlu yapımızla, sürükle-bırak ve çift tıklama ile düzenleme gibi modern web teknolojilerini kullanarak hızlı çözümler sunuyoruz.</p>
      </div>

      <div v-if="infoModalType === 'privacy'">
        <p>Gizliliğiniz bizim için önemlidir. Bu web sitesi, kullanıcı deneyimini iyileştirmek ve trafik analizi yapmak amacıyla çerezler (cookies) kullanmaktadır.</p>
        <p><strong>Reklamlar:</strong> Google AdSense gibi üçüncü taraf reklam sağlayıcıları, sitemize yaptığınız ziyaretlere dayalı olarak reklam sunmak için çerezleri kullanabilir. Bu çerezler, ilgi alanlarınıza göre reklam gösterilmesini sağlar.</p>
        <p><strong>Veri Saklama:</strong> Tasarladığınız şablonlar sadece tarayıcınızın yerel depolama alanında (localStorage) tutulur, sunucularımıza gönderilmez.</p>
      </div>

      <div v-if="infoModalType === 'contact'">
        <p>Uygulama hakkında sorularınız, önerileriniz veya teknik destek talepleriniz için bize ulaşabilirsiniz:</p>
        <p style="background: #f1f5f9; padding: 15px; border-radius: 8px;">
          📧 <strong>E-posta:</strong> info@efaturasablon.com<br>
          🌐 <strong>Web:</strong> www.efaturasablon.com
        </p>
      </div>

    </div>
  </div>
</div>
    <div class="modal-footer">
      <button @click="showHelpModal = false" class="btn btn-primary">Anladım, Başlayalım!</button>
    </div>
  </div>
</div>
<div v-if="showPrivacyModal" class="modal-overlay" @click.self="showPrivacyModal = false">
  <div class="help-modal privacy-modal">
    <div class="modal-header">
      <h2>🛡️ Gizlilik Politikası</h2>
      <button @click="showPrivacyModal = false" class="close-btn">✕</button>
    </div>
    <div class="modal-content">
      <div class="privacy-section">
        <h3>1. Veri İşleme Prensibimiz (Yerel Çalışma)</h3>
        <p>Bu uygulama "Client-Side" (İstemci Taraflı) çalışma prensibine sahiptir. Yüklediğiniz XML fatura dosyaları, logolar veya düzenlediğiniz metinler hiçbir şekilde uzak bir sunucuya (server) gönderilmez veya veritabanımızda saklanmaz. Tüm işlemler tarayıcınızın içinde gerçekleşir.</p>
      </div>
      <div class="privacy-section">
        <h3>2. Saklanan Veriler ve Amacı</h3>
        <p>Uygulama, kullanım deneyiminizi iyileştirmek için tarayıcınızın Yerel Depolama (localStorage) özelliğini kullanır:

XSLT Şablon Değişiklikleri: Yaptığınız tasarım değişikliklerinin sayfa yenilendiğinde kaybolmaması için tarayıcınızda saklanır.

Logolar: Tasarıma eklediğiniz logolar, tekrar yükleme zahmetinden kurtulmanız için tarayıcı hafızasında tutulur.

Geçici Notlar: Editör ile eklediğiniz notlar yerel cihazınızda saklanır.</p>
      </div>
      <div class="privacy-section">
        <h3>3. Üçüncü Taraf Eklentiler</h3>
        <p>Uygulamamızda kullanılan düzenleme araçları (örneğin: TinyMCE) kendi gizlilik politikalarına sahip olabilir. Bu araçlar sadece düzenleme işlevini yerine getirmek için kullanılır.</p>
      </div>
      <div class="privacy-section">
        <h3>4. Kullanıcı Kontrolü</h3>
        <p>Verileriniz tamamen sizin kontrolünüzdedir. Tarayıcı geçmişinizi veya site verilerini temizlediğinizde, uygulama tarafından tarayıcıya kaydedilen tüm şablon ve logo verileri kalıcı olarak silinir.</p>
      </div>
      <div class="privacy-section">
        <h3>5. Güvenlik</h3>
        <p>Verileriniz cihazınızdan dışarı çıkmadığı için, siber saldırı veya sunucu sızıntısı gibi riskler minimum düzeydedir. Yine de, hassas veriler içeren XML dosyalarını halka açık (public) bilgisayarlarda kullanırken işlem bittikten sonra "Tarayıcı Verilerini Temizle" seçeneğini kullanmanızı öneririz.</p>
      </div>
      <div class="privacy-section">
        <p><b>Çerezler ve Reklamlar:</b> Sitemiz, kullanıcı deneyimini iyileştirmek ve ziyaretçi trafiğini analiz etmek için çerezler (cookies) kullanmaktadır. Ayrıca, Google AdSense gibi üçüncü taraf reklam sağlayıcıları, sitemize veya internetteki diğer sitelere yaptığınız ziyaretlere dayanarak size özel reklamlar sunmak amacıyla çerezleri kullanabilir. Kullanıcılar, Google reklam ve içerik ağı gizlilik politikasını ziyaret ederek bu çerezlerin kullanılmasını engelleyebilirler."</p>
      </div>
    <div>
      <p>Sitemiz çerezler (cookies) kullanmaktadır. Google AdSense reklamları için çerez verileri işlenebilir.</p>
    </div>
    </div>
  </div>
</div>
    <div v-if="xsltText && showInfoBanner" class="info-banner">
  <div class="banner-content">
    <span class="magic-icon">✨</span>
    <p><strong>İpucu:</strong> Fatura üzerindeki metinleri değiştirmek için <strong>metne çift tıklayın!</strong></p>
  </div>
  
  <div style="display: flex; align-items: center; gap: 15px;">
    <div class="mouse-animation">
      <div class="mouse">
        <div class="click-wave"></div>
      </div>
    </div>
    <button @click="showInfoBanner = false" class="close-banner-btn" title="Kapat">✕</button>
  </div>
</div>
    <header>
      <div class="header-top">
        <h1>E-Fatura XSLT Tasarım Aracı</h1>
        <div class="header-actions">
          
          <button @click="showHelpModal = true" class="btn btn-secondary" style="background: #6366f1;">
    ❓ Nasıl Kullanılır?
  </button>
          <button @click="$refs.xmlInput.click()" class="btn btn-secondary" style="background: #10b981;">
            📥 Fatura XML Değiştir
          </button>
          <input type="file" ref="xmlInput" @change="e => handleXmlUpload(e)" accept=".xml" hidden />
          <button @click="transform" :disabled="!xsltText" class="btn btn-primary">⚡ Faturayı Oluştur</button>
          <button @click="downloadXslt" :disabled="!xsltText" class="btn btn-secondary">💾 XSLT İndir</button>
        </div>
      </div>

      <div 
        class="dropzone main-dropzone" 
        :class="{ 'dropzone-active': isDraggingXslt }"
        @dragover.prevent="isDraggingXslt = true"
        @dragleave.prevent="isDraggingXslt = false"
        @drop.prevent="handleXsltDrop"
        @click="$refs.xsltInput.click()"
      >
        <input type="file" ref="xsltInput" @change="e => handleXsltUpload(e)" accept=".xslt,.xsl" hidden />
        <div class="dropzone-content">
          <span class="icon">{{ xsltText ? '✅' : '📄' }}</span>
          <div class="text">
            <p v-if="!fileName"><strong>XSLT dosyasını sürükleyin</strong> veya tıklayın</p>
            <p v-else class="success">Şablon Yüklendi: <strong>{{ fileName }}</strong></p>
            <small>Fatura şablonunuzu (XSLT) buraya ekleyin</small>
          </div>
        </div>
      </div>
    </header>

    <div v-if="!xsltText" class="welcome-screen">
      <div class="welcome-card">
        <span class="welcome-icon">📄</span>
        <h2>Tasarım Aracına Hoş Geldiniz</h2>
        <p>Düzenlemeye başlamak için lütfen bir şablon yükleyin veya hazır bir şablonla başlayın.</p>
        <div class="welcome-actions">
          <button @click="$refs.xsltInput.click()" class="btn btn-primary btn-lg">📂 Bilgisayardan Şablon Yükle</button>
          <button @click="loadInitialTemplate" class="btn btn-secondary btn-lg">✨ Varsayılan Şablonla Başla</button>
        </div>
      </div>
    </div>

    <div class="quick-edit-bar" v-if="xsltText">
      <div class="logo-selector-wrapper">
        <label>Logo:</label>
        <div 
          class="logo-dropzone"
          :class="{ 'logo-active': isDraggingLogo }"
          @dragover.prevent="isDraggingLogo = true"
          @dragleave.prevent="isDraggingLogo = false"
          @drop.prevent="handleLogoDrop"
          @click="$refs.logoInput.click()"
        >
          <input type="file" ref="logoInput" @change="handleLogoUpload" accept="image/*" hidden />
          <span v-if="!logoUploaded">🖼️ Logo Seç/Sürükle</span>
          <span v-else class="success">✅ Güncellendi</span>
        </div>
      </div>

      <div v-if="xsltText.includes('data:image')" style="display: flex; gap: 5px; margin-left: 10px;">
        <button @click="updateAlignment('left')" class="btn-icon" title="Sola Taşı">⬅️ Sola Taşı</button>
        <button @click="updateAlignment('right')" class="btn-icon" title="Sağa Taşı">➡️ Sağa Taşı</button>
      </div>

      <div class="logo-selector-wrapper" style="margin-left: 10px; border-left: 1px solid #ddd; padding-left: 10px;">
        <label style="display: flex; align-items: center; gap: 5px; cursor: pointer; font-size: 12px;">
          <input type="checkbox" v-model="logoShadowEnabled" @change="toggleLogoStyle"> 
          Çerçeve ve Gölge Ekle
        </label>
      </div>

      <div v-if="logoShadowEnabled" style="display: flex; align-items: center; gap: 5px;">
        <input type="color" v-model="logoShadowColor" @input="toggleLogoStyle">
        <small>Gölge Rengi</small>
      </div>
      <div class="logo-selector-wrapper" style="margin-left: 10px; border-left: 1px solid #ddd; padding-left: 10px;">
  <label style="display: flex; align-items: center; gap: 5px; cursor: pointer; font-size: 12px;">
    <input type="checkbox" v-model="logoAsBackground" @change="reapplyLogoEffect"> 
    Logoyu Tabloya Arka Plan Yap
  </label>
</div>
<div class="logo-selector-wrapper" style="margin-left: 10px; border-left: 1px solid #ddd; padding-left: 10px; display: flex; align-items: center; gap: 8px;">
  <label style="font-size: 13px; font-weight: bold; color: #94a3b8;">Tablo Rengi:</label>
  <div style="display: flex; align-items: center; gap: 8px;">
    <input 
      type="color" 
      v-model="themeColor" 
      @input="applyTheme" 
      style="width: 25px; height: 25px; border: none; cursor: pointer; background: none;"
    >
    
    <div class="color-presets" style="display: flex; gap: 4px;">
      <button 
        v-for="color in ['#3b82f6', '#ef4444', '#10b981', '#f59e0b', '#8b5cf6']" 
        :key="color"
        @click="themeColor = color; applyTheme()"
        type="button"
        class="preset-color-btn"
        :style="{ backgroundColor: color }"
        :title="color"
      ></button>
    </div>
    
    <small style="font-family: monospace; color: #64748b; font-size: 11px;">{{ themeColor.toUpperCase() }}</small>
  </div>
</div>
<div class="setting-item" style="background: #f8fafc; padding: 10px 14px; border-radius: 8px; border: 1px solid #e2e8f0; margin-bottom: 10px; display: flex; align-items: center; justify-content: space-between;">
  <label style="font-size: 13px; font-weight: 600; color: #475569;">🔤 Yazı Tipi</label>
  <select 
    v-model="selectedFont" 
    @change="applyFontFamily"
    style="padding: 4px 8px; border-radius: 6px; border: 1px solid #cbd5e1; font-size: 12px; color: #64748b; background: white; cursor: pointer;"
  >
    <option v-for="font in fontOptions" :key="font.value" :value="font.value">
      {{ font.name }}
    </option>
  </select>
</div>
      <div class="template-selector" style="margin-left: 10px; display: flex; align-items: center; gap: 10px;">
        <span style="font-size: 13px; font-weight: bold; color: #94a3b8;">Hızlı Şablon:</span>
        <select @change="loadPresetTemplate" class="preset-select">
          <option value="">--- Şablon Seç ---</option>
          <option v-for="temp in presetTemplates" :key="temp.path" :value="temp.path">{{ temp.name }}</option>
        </select>
      </div>

      <button 
  @click="resetTextChanges" 
  class="reset-text-btn"
>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
    <path d="M3 3v5h5"></path>
  </svg>
  Metinleri Sıfırla
</button>
<div class="setting-item" style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px;">
  <label style="font-size: 13px; font-weight: bold;">Yazı Rengi:</label>
  <input 
    type="color" 
    v-model="fontColor" 
    @input="applyFontColor" 
    style="width: 40px; height: 25px; cursor: pointer; border: 1px solid #ccc; padding: 0;"
  />
  <span style="font-size: 12px; color: #666;">{{ fontColor }}</span>
</div>

      <div class="content-wizard">
        <div class="wizard-group">
          <input type="number" v-model="tableSettings.rows" class="small-input">
          <input type="number" v-model="tableSettings.cols" class="small-input">
          <button @click="generateAndAddTable" class="btn-icon">📊</button>
        </div>
        
        
      </div>
    </div>

    <main class="main-content" v-if="xsltText" :class="{ 'sidebar-closed': !isSidebarOpen }">
  
  <div class="panel editor-panel" v-show="isSidebarOpen">
    <div class="panel-header">XSLT Kod Editörü</div>
    <textarea v-model="xsltText" spellcheck="false"></textarea>
  </div>

  <button @click="isSidebarOpen = !isSidebarOpen" class="toggle-sidebar-btn" :title="isSidebarOpen ? 'Kodu Gizle' : 'Kodu Göster'">
    {{ isSidebarOpen ? '◀' : '▶' }}
  </button>

  <div class="panel history-panel" v-show="isSidebarOpen" style="flex: 0 0 250px;">
    <div class="panel-header">💾 Versiyon Geçmişi ({{ history.length }}/10)</div>
    <div class="history-controls" style="padding: 10px; border-bottom: 1px solid #eee;">
      <input type="text" v-model="versionNote" placeholder="Neyi değiştirdiniz? (Zorunlu)" class="text-input" style="width: 100%; margin-bottom: 5px;" @keyup.enter="saveSnapshot(versionNote)">
      <button @click="saveSnapshot(versionNote)" class="btn btn-primary" style="width: 100%; font-size: 11px;" :disabled="!versionNote.trim()">Versiyonu Kaydet</button>
    </div>
    <div class="history-list" style="overflow-y: auto; flex: 1;">
      <div v-for="(item, index) in history.slice().reverse()" :key="item.id" class="history-item" :class="{ active: (history.length - 1 - index) === historyIndex }" @click="restoreVersion(history.length - 1 - index)" :style="{ cursor: (history.length - 1 - index) === historyIndex ? 'default' : 'pointer' }">
        <div class="history-item-info">
          <strong>{{ item.note }}</strong>
          <small>{{ item.timestamp }}</small>
        </div>
        <button @click.stop="deleteVersion(history.length - 1 - index)" class="delete-btn">✕</button>
      </div>
    </div>
  </div>

  <div class="panel preview-panel">
    <div class="panel-header">Fatura Önizleme</div>
    <div v-if="showFloatingEditor" class="tiny-floating-panel" :style="editorPos">
      <div class="tiny-panel-header">
        <span>📝 Notu Düzenle</span>
        <button @click="closeEditor" class="close-btn">✖</button>
      </div>
      <div id="tiny-editor-container"></div>
      <div class="tiny-panel-footer">
        <button @click="saveAndCloseEditor" class="save-btn" style="margin:10px;">Faturaya Uygula</button>
      </div>
    </div>
    <iframe v-if="previewHtml" :srcdoc="previewHtml" @load="injectInteractions" id="preview-frame" class="preview-iframe"></iframe>
  </div>
</main>
    <div v-if="showDeleteModal" class="modal-overlay">
  <div class="modal-card">
    <h3>⚠️ Versiyonu Sil?</h3>
    <p><strong>"{{ history[itemToDelete]?.note }}"</strong> başlıklı versiyon kalıcı olarak silinecektir. Emin misiniz?</p>
    <div class="modal-actions">
      <button @click="showDeleteModal = false" class="btn btn-secondary">Vazgeç</button>
      <button @click="confirmDelete" class="btn btn-primary" style="background: #ef4444;">Evet, Sil</button>
    </div>
  </div>
</div>
<div v-if="showLimitModal" class="modal-overlay">
  <div class="modal-card">
    <div style="font-size: 40px; margin-bottom: 10px;">🚫</div>
    <h3>Maksimum Sınıra Ulaşıldı</h3>
    <p>Sistem güvenliği ve tarayıcı performansı için en fazla <b>10 versiyon</b> kaydedebilirsiniz.</p>
    <p>Yeni bir yer açmak için lütfen listedeki gereksiz versiyonları silin.</p>
    <div class="modal-actions">
      <button @click="showLimitModal = false" class="btn btn-primary">Anladım</button>
    </div>
  </div>
</div>
<div v-if="showWarningModal" class="modal-overlay" @click.self="showWarningModal = false">
      <div class="help-modal" style="border-top: 5px solid #f59e0b;">
        <div class="modal-header">
          <h2 style="color: #d97706;">⚠️ Dış Kaynaklı Şablon</h2>
          <button @click="showWarningModal = false" class="close-btn">✕</button>
        </div>
        <div class="modal-content" style="text-align: center;">
          <div style="font-size: 50px; margin-bottom: 15px;">🔍</div>
          <p>Bu şablon <strong>XSLT Tasarım Aracı</strong> ile oluşturulmamış görünüyor.</p>
          <p style="color: #64748b; font-size: 13px; margin-top: 10px;">
            Dışarıdan yüklenen dosyalarda düzenleme özellikleri kısıtlı olabilir. Devam etmek istiyor musunuz?
          </p>
        </div>
        <div class="modal-footer" style="display: flex; gap: 10px; justify-content: center; padding: 20px;">
          <button @click="showWarningModal = false" class="btn btn-secondary">İptal Et</button>
          <button @click="confirmUpload" class="btn btn-primary" style="background: #d97706;">Yine de Yükle</button>
        </div>
      </div>
    </div>
    <footer class="app-footer">
  <div class="footer-content">
    <div class="footer-section">
      <h4>İletişim & Destek</h4>
      <p>Sorularınız için: <a href="mailto:yildirim.irfann@gmail.com">yildirim.irfann@gmail.com</a></p>
    </div>
    <div class="footer-section">
      
    <div class="footer-links">
      <a href="#" @click.prevent="showPrivacyModal = true">Gizlilik Politikası</a>
      
  <a href="#" @click.prevent="openInfoModal('about')">Hakkımızda</a>
  <span class="footer-divider"></span>
  <a href="#" @click.prevent="openInfoModal('privacy')">XSLT Nedir?</a>
  <span class="footer-divider"></span>
  <a href="#" @click.prevent="openInfoModal('contact')">İletişim</a>

    </div>
</div>
    <div class="footer-divider"></div>
    
    <div class="footer-section">
      <h4>Hızlı Bağlantılar</h4>
      <div class="footer-links">
        <a href="https://kilavuz.efaturasablon.com" target="_blank">Kullanım Kılavuzu</a>
        <a href="https://github.com" target="_blank">GitHub</a>
        <!--<a href="#" title="Bize kahve ısmarla!">☕ Bağış Yap</a>-->
      </div>
    </div>
  </div>
  
  <div class="footer-bottom">
    <p>&copy; 2026 eFatura Tasarım Aracı. Tüm hakları saklıdır. | <span class="support-text">Reklamlara tıklayarak bize destek olabilirsiniz.</span></p>
  </div>
</footer>
<div v-if="infoModalActive" class="modal-overlay" @click.self="infoModalActive = false" style="z-index: 9999;">
  <div class="help-modal"> <div class="modal-header">
      <h2 v-if="infoModalType === 'about'">ℹ️ Hakkımızda</h2>
      <h2 v-if="infoModalType === 'privacy'">🛡️ XSLT nedir</h2>
      <h2 v-if="infoModalType === 'contact'">📞 İletişim</h2>
      <button @click="infoModalActive = false" class="close-btn">✕</button>
    </div>
    
    <div class="modal-content">
      <div v-if="infoModalType === 'about'">
        <p>"E-Fatura Tasarım Aracı, teknik XSLT kodlama bilgisine ihtiyaç duymadan, görsel bir arayüz üzerinden profesyonel e-fatura şablonları oluşturabilmesi amacıyla geliştirilmiştir. Karmaşık XML yapılarını kullanıcı dostu bir düzenleyiciye dönüştürüyoruz. Anlık önizleme ve çift tıklama ile metin düzenleme gibi modern web teknolojilerini kullanarak, dijital dönüşüm süreçlerinizi hızlandırmayı hedefliyoruz."</p>
      </div>

      <div v-if="infoModalType === 'privacy'">
        <p>Bir e-fatura şablonu hazırlamak aslında üç ana adımdan oluşur:

GİB Standartlarını Bilmek: Gelir İdaresi Başkanlığı, faturada hangi bilgilerin (TC No, Adres, Vergi Dairesi vb.) mutlaka olması gerektiğini belirler. Şablonunuzun temeli bu kurallara dayanmalıdır.

Tasarımı Oluşturmak: Faturanızın nasıl görüneceğine karar verirsiniz. Tablo yapısı, yazı fontları ve renkler bu aşamada belirlenir. Eskiden bu işlem için çok ağır kod yazmak gerekiyordu.

XSLT Koduna Dönüştürmek: Hazırlanan tasarımın, e-fatura sisteminin tanıyacağı XSLT formatına çevrilmesi gerekir.</p>
<br />
<i>"Normalde e-fatura şablonu hazırlamak için uzman seviyesinde yazılım bilgisi gerekir. Ancak bizim E-Fatura Tasarım Aracımız sayesinde, kodlarla uğraşmanıza gerek kalmadan, logo ekleyebilir, tablo ve metin renklendirme yapabilir, not alanına tablo ekleyebilir, metinlere çift tıklayarak dakikalar içinde profesyonel XSLT şablonlarınızı oluşturabilirsiniz."</i>
      </div>

      <div v-if="infoModalType === 'contact'">
        <p>E-Fatura Tasarım Aracı ile ilgili her türlü sorunuz, teknik destek talepleriniz için mail gönderebilirsiniz</p>
        <p>Destek: yildirim.irfann@gmail.com</p>
        <br />
        <p>Eğer uygulama içinde bir teknik hata (bug) ile karşılaşırsanız, lütfen kullandığınız tarayıcı bilgisini ve hatanın ekran görüntüsünü e-posta adresimize iletin. En kısa sürede çözüm üretmekten mutluluk duyarız."</p>
      </div>
    </div>
  </div>
</div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue';

const infoModalActive = ref(false);
const infoModalType = ref('');

const openInfoModal = (type) => {
  console.log("Modal açılıyor:", type); // Tarayıcı konsolunda kontrol etmek için
  infoModalType.value = type;
  infoModalActive.value = true;
};

const xmlText = ref('');
const xsltText = ref('');
const previewHtml = ref('');
const fileName = ref('');
const isDraggingXslt = ref(false);
const isDraggingLogo = ref(false);
const logoUploaded = ref(false);
const tableSettings = ref({ rows: 2, cols: 2 });

const logoShadowEnabled = ref(false); // Başlangıçta kapalı
const logoShadowColor = ref('#000000');
const presetTemplates = ref([
  { name: 'Düzenlenmiş Şablon', path: '/templates/general.xslt' },
  { name: 'Varsayılan Gib Şablonu', path: '/templates/varsayilan-template.xslt' },
  { name: 'Minimal Tasarım', path: '/templates/minimal.xslt' },
  { name: 'Gölgeli Tasarım', path: '/templates/golgeli-tasarim.xslt' },
  { name: 'Çizgisiz Tablo Tasarımı', path: '/templates/general-cizgisiz.xslt' }
]);


const selectedFont = ref('Arial, sans-serif');
const fontOptions = [
  { name: 'Tahoma (En Güvenli)', value: 'Tahoma, sans-serif' },
  { name: 'Arial (Standart)', value: 'Arial, Helvetica, sans-serif' },
  { name: 'Verdana (Geniş/Okunaklı)', value: 'Verdana, Geneva, sans-serif' },
  { name: 'Trebuchet MS', value: "'Trebuchet MS', Helvetica, sans-serif" },
  { name: 'Times New Roman (Klasik)', value: "'Times New Roman', Times, serif" },
  { name: 'Georgia (Zarif Serif)', value: 'Georgia, serif' },
  { name: 'Courier New (Teknik/Kod)', value: "'Courier New', Courier, monospace" }
];
// Geçmiş yönetimi için
const history = ref([]);
const historyIndex = ref(-1);

// Manuel versiyon ismi için
const versionNote = ref("");

const showDeleteModal = ref(false);
const itemToDelete = ref(null);
const showInfoBanner = ref(true); // Banner'ın görünürlük durumu
const logoAsBackground = ref(false);
const showLimitModal = ref(false); // Sınır uyarısı modalı için
const themeColor = ref('#3b82f6'); // Varsayılan mavi
const isSidebarOpen = ref(true); // Panel durumu (açık/kapalı)
const showHelpModal = ref(false); // Yardım modalı kontrolü
const showWarningModal = ref(false); // Modal açma/kapama
const pendingXsltContent = ref('');  // Onay bekleyen XSLT metni
const pendingFileName = ref('');     // Onay bekleyen dosya adı
const userTextChanges = ref(JSON.parse(localStorage.getItem('userTextChanges') || '{}'));
const fontColor = ref('#000000'); // Varsayılan olarak siyah renk
const templatePath = ref(''); // Mevcut şablonun dosya yolunu tutacak
const showPrivacyModal = ref(false);
// Yerel depolama (Local Storage) anahtarı
const STORAGE_KEY = 'xslt_editor_snapshots';

onMounted(async () => {
  const savedHistory = localStorage.getItem(STORAGE_KEY);
  if (savedHistory) {
    history.value = JSON.parse(savedHistory);
    historyIndex.value = history.value.length - 1;
  }
  
  // Mevcut XML yükleme kodun...
  try {
    const response = await fetch('/TemelFaturaOrnegi.xml');
    if (response.ok) xmlText.value = await response.text();
  } catch (err) { console.error("XML yüklenemedi"); }
});

const handleXsltUpload = (event) => {
  handleXsltFile(event.target.files[0]);
  event.target.value = ""; 
};
const handleXsltDrop = (e) => { isDraggingXslt.value = false; processXslt(e.dataTransfer.files[0]); };

// XML Yükleme İşlemleri
const handleXmlUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;
  const reader = new FileReader();
  reader.onload = (e) => {
    xmlText.value = e.target.result;
    if (xsltText.value) transform(); // XSLT varsa anında önizlemeyi güncelle
  };
  reader.readAsText(file);
};

// Şablonu ekrana basar ama VERSİYON ATMAZ (saveSnapshot yok)
// Şablonu ekrana basar ama VERSİYON ATMAZ (saveSnapshot yok)
const applyXslt = (content, name) => {
  xsltText.value = content;
  fileName.value = name;
  
  // Ayarları senkronize et
  syncSettingsFromCode(content);
  
  // Tema ve font ayarlarını uygula
  setTimeout(() => {
    applyTheme();
    applyFontFamily();
    applyFontColor();
    transform();
  }, 200);
};

// Modalda "Yine de Yükle" deyince çalışır
const confirmUpload = () => {
  applyXslt(pendingXsltContent.value, pendingFileName.value);
  showWarningModal.value = false;
};

const processXslt = (file) => {
  if (!file) return;
  fileName.value = file.name;
  const reader = new FileReader();
  reader.onload = (e) => { 
    const content = e.target.result;
    xsltText.value = content; 
    
    // Ayarları senkronize et
    syncSettingsFromCode(content);
    
    // Tema ve font ayarlarını uygula (şablonda yoksa varsayılan değerlerle)
    setTimeout(() => {
      applyTheme();
      applyFontFamily();
      applyFontColor();
      transform();
    }, 200);
  };
  reader.readAsText(file);
};

const applyFontFamily = () => {
  let content = xsltText.value;
  const fontValue = selectedFont.value;

  // Eski font ailesi stilini temizle
  content = content.replace(/<style[^>]*id="dynamic-font-family-style"[^>]*>[\s\S]*?<\/style>/gi, "");
  
  // Yeni stil bloğu oluştur
  const styleTag = `\n<style id="dynamic-font-family-style">#mainbody { font-family: ${fontValue} !important; }</style>\n`;
  
  // XSLT'ye enjekte et
  if (content.includes('</head>')) {
    content = content.replace('</head>', styleTag + '</head>');
  } else if (content.includes('</xsl:template>')) {
    content = content.replace('</xsl:template>', styleTag + '</xsl:template>');
  } else {
    content = content.replace(/(<xsl:template[^>]*>)/i, `$1${styleTag}`);
  }
  
  xsltText.value = content;
  transform();
};
// Koddan ayarları okuyan yeni fonksiyon
const syncSettingsFromCode = (content) => {
  if (!content) return;

  // 1. Logo Gölge ve Çerçeve Kontrolü
  const logoTagMatch = content.match(/<img[^>]*id="user-added-logo"[^>]*style="([^"]*)"/i);
  
  if (logoTagMatch) {
    const logoStyle = logoTagMatch[1];
    const hasShadow = logoStyle.includes('box-shadow:');
    const hasBorder = logoStyle.includes('border:');
    logoShadowEnabled.value = hasShadow || hasBorder;

    const shadowMatch = logoStyle.match(/box-shadow:[^;]*rgba\((\d+),\s*(\d+),\s*(\d+)/i);
    if (shadowMatch) {
      const r = parseInt(shadowMatch[1]);
      const g = parseInt(shadowMatch[2]);
      const b = parseInt(shadowMatch[3]);
      logoShadowColor.value = "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    } else {
      const hexMatch = logoStyle.match(/box-shadow:[^;]*(#[a-f\d]{6})/i);
      if (hexMatch) logoShadowColor.value = hexMatch[1];
    }
  } else {
    logoShadowEnabled.value = false;
  }

  // 2. Tema (Tablo) Rengi Kontrolü - DÜZELTİLDİ
  // Birden fazla şekilde tema rengini aramalıyız
  let foundThemeColor = null;
  
  // Stil bloğu içinde arıyoruz
  const themeStyleMatch = content.match(/<style[^>]*id="theme-style"[^>]*>([\s\S]*?)<\/style>/i);
  if (themeStyleMatch) {
    const styleContent = themeStyleMatch[1];
    // border: 2px solid #3b82f6 !important; şeklinde arıyoruz
    const borderMatch = styleContent.match(/border:[^;!]*solid\s*(#[a-f\d]{6}|#[a-f\d]{3})/i);
    if (borderMatch) foundThemeColor = borderMatch[1];
    
    // background-color: #3b82f6 !important; şeklinde de arıyoruz
    if (!foundThemeColor) {
      const bgMatch = styleContent.match(/background-color:\s*(#[a-f\d]{6}|#[a-f\d]{3})/i);
      if (bgMatch) foundThemeColor = bgMatch[1];
    }
  }
  
  // Varsayılan renkleri de kontrol edelim
  if (!foundThemeColor) {
    const defaultColors = content.match(/#(ef4444|3b82f6|10b981|f59e0b|8b5cf6)/i);
    if (defaultColors) foundThemeColor = '#' + defaultColors[1];
  }
  
  if (foundThemeColor) {
    themeColor.value = foundThemeColor;
  }

  // 3. Arka Plan Logo Kontrolü
  logoAsBackground.value = content.includes('id="bg-style"');

  // 4. FONT RENGİ KONTROLÜ - DÜZELTİLDİ
  let foundFontColor = null;
  
  // Stil bloğu içinde arıyoruz
  const fontColorStyleMatch = content.match(/<style[^>]*id="dynamic-font-color"[^>]*>([\s\S]*?)<\/style>/i);
  if (fontColorStyleMatch) {
    const fontStyleContent = fontColorStyleMatch[1];
    const colorMatch = fontStyleContent.match(/#mainbody[^{]*{[\s\S]*?color:\s*(#[a-f\d]{6}|#[a-f\d]{3}|[a-z]+)/i);
    if (colorMatch) foundFontColor = colorMatch[1];
  }
  
  // Başka yerlerde de font rengini arayalım
  if (!foundFontColor) {
    const inlineColorMatch = content.match(/color:\s*(#[a-f\d]{6}|#[a-f\d]{3}|[a-z]+)\s*!important/i);
    if (inlineColorMatch) foundFontColor = inlineColorMatch[1];
  }
  
  if (foundFontColor) {
    fontColor.value = foundFontColor;
  }

  // 5. FONT AİLESİ KONTROLÜ - DÜZELTİLDİ
  let foundFontFamily = null;
  
  const fontFamilyStyleMatch = content.match(/<style[^>]*id="dynamic-font-family-style"[^>]*>([\s\S]*?)<\/style>/i);
  if (fontFamilyStyleMatch) {
    const familyStyleContent = fontFamilyStyleMatch[1];
    const familyMatch = familyStyleContent.match(/#mainbody[^{]*{[\s\S]*?font-family:\s*([^;!}]+)/i);
    if (familyMatch) foundFontFamily = familyMatch[1].trim();
  }
  
  if (foundFontFamily) {
    selectedFont.value = foundFontFamily;
  }
};

const handleLogoUpload = (e) => {
  const file = e.target.files[0];
  if (file) processLogo(file);
};


const processLogo = (file) => {
  if (!file) return;
  const reader = new FileReader();
  reader.onload = (e) => {
    const base64Image = e.target.result;
    const targetId = 'fatura-logosu-alani';
    const solId = 'logo-sol-alan';
    let text = xsltText.value;

    // --- 1. Üst Logo Yerleşimi ---
    let shadowStyle = "";
    if (logoShadowEnabled.value) {
      const hex = logoShadowColor.value;
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      shadowStyle = `border: 1px solid #ddd; box-shadow: 0 4px 8px rgba(${r}, ${g}, ${b}, 0.2); `;
    }
    const newImgTag = `<img id="user-added-logo" src="${base64Image}" style="width: 250px; cursor: move; margin-bottom: 10px; ${shadowStyle} padding: 5px; background: #fff;" draggable="true" />`;
    const isCurrentlyOnLeft = text.includes(`id="${solId}"`) && new RegExp(`<div id="${solId}"[^>]*>\\s*<img`, 'i').test(text);
    const activeTargetId = isCurrentlyOnLeft ? solId : targetId;
    text = text.replace(/<img[^>]*id="user-added-logo"[^>]*>/gi, "");
    const cleanDivs = new RegExp(`(<div id="(?:${solId}|${targetId})"[^>]*>)([\\s\\S]*?)(<\\/div>)`, 'gi');
    text = text.replace(cleanDivs, '$1&#160;$3');
    const fillPattern = new RegExp(`(<div id="${activeTargetId}"[^>]*>)([\\s\\S]*?)(<\\/div>)`, 'i');
    text = text.replace(fillPattern, `$1${newImgTag}$3`);

    xsltText.value = text;
    logoUploaded.value = true;

    // --- 2. Kritik Ekleme: Logo değişince arka planı da tazele ---
    if (logoAsBackground.value) {
      setTimeout(() => { reapplyLogoEffect(); }, 50);
    } else {
      setTimeout(() => { transform(); }, 150);
    }
  };
  reader.readAsDataURL(file);
};

const appendToNotes = (newHtml) => {
  const targetId = 'tinyNotesTableTd';
  
  // HTML karakterlerini XML için güvenli hale getir
  const escapedContent = newHtml
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  // ÖNEMLİ: disable-output-escaping="yes" faturayı açan her programa "BUNU ÇİZ" der.
  const wrappedHtml = `<div id="editableNoteWrapper"><xsl:text disable-output-escaping="yes">${escapedContent}</xsl:text></div>`;
  
  const regex = new RegExp(`(<td id="${targetId}"[^>]*>)([\\s\\S]*?)(<\\/td>)`, 'i');
  
  if (xsltText.value.match(regex)) {
    xsltText.value = xsltText.value.replace(regex, `$1${wrappedHtml}$3`);
    transform();
    localStorage.setItem('userTextChanges', JSON.stringify(userTextChanges.value));
  }
};

const generateAndAddTable = () => {
  let tableHtml = `<table border="1" style="width:100%; border-collapse: collapse; margin-top: 10px;">`;
  for (let r = 0; r < tableSettings.value.rows; r++) {
    tableHtml += `<tr>`;
    for (let c = 0; c < tableSettings.value.cols; c++) {
      tableHtml += `<td style="padding: 5px; border: 1px solid #ccc;">Veri</td>`;
    }
    tableHtml += `</tr>`;
  }
  tableHtml += `</table>`;
  appendToNotes(tableHtml);
};

// --- Iframe Etkileşimleri (Onarıcı ve Editör) ---
const injectInteractions = () => {
  const iframe = document.getElementById('preview-frame');
  if (!iframe) return;
  const doc = iframe.contentDocument || iframe.contentWindow.document;

  // 1. KODLARI CANLI TABLOYA ÇEVİRME OPERASYONU
  const editableWrapper = doc.getElementById('editableNoteWrapper');
  if (editableWrapper) {
    // innerText kullanarak ekranda gördüğün o ham "<p>Buraya..." yazısını çekiyoruz
    const rawContent = editableWrapper.innerText || editableWrapper.textContent;
    
    const forceRender = (str) => {
      const txt = document.createElement("textarea");
      txt.innerHTML = str;
      let decoded = txt.value;
      
      // Eğer hala &lt; gibi ifadeler varsa (double encoding), bir tur daha çöz
      if (decoded.includes('&lt;') || decoded.includes('&gt;')) {
        txt.innerHTML = decoded;
        decoded = txt.value;
      }
      return decoded;
    };

    const finalHtml = forceRender(rawContent);

    // Eğer içerik gerçekten HTML kodları içeriyorsa, 
    // innerText yerine innerHTML kullanarak tarayıcıyı bunları ÇİZMEYE zorluyoruz.
    if (finalHtml.includes('<') && finalHtml.includes('>')) {
      editableWrapper.innerHTML = finalHtml;
    }
  }

  // 2. TIKLAMA OLAYLARINI BAĞLAMA
  const noteArea = doc.getElementById('tinyNotesTableTd');
  if (noteArea) {
    noteArea.style.cursor = 'pointer';
    noteArea.title = "Düzenlemek için tıklayın";
    
    noteArea.onclick = (event) => {
      const rect = iframe.getBoundingClientRect();
      // Onardığımız veya ana alanı editöre gönder
      const targetDiv = doc.getElementById('editableNoteWrapper') || noteArea;
      openTinyEditor(targetDiv, event, rect);
    };
  }

  // 3. ÇİFT TIKLAMA (Genel Metinler)
  doc.body.addEventListener('dblclick', (e) => {
    const target = e.target;
    const forbidden = ['TABLE', 'TR', 'TD', 'TH', 'TBODY', 'THEAD', 'IMG', 'UL', 'LI'];
    if (forbidden.includes(target.tagName)) return;

    const currentText = target.innerText.trim();
    if (currentText) {
      const newText = prompt("Metni Düzenle:", currentText);
      if (newText !== null && newText !== currentText) {
        target.innerText = newText;
        xsltText.value = xsltText.value.replace(currentText, newText);
        // Persist
        userTextChanges.value[currentText] = newText;
        localStorage.setItem('userTextChanges', JSON.stringify(userTextChanges.value));
      }
    }
  });
};

const updateAlignment = (targetSide) => {
  const solId = 'logo-sol-alan';
  const sagId = 'fatura-logosu-alani';
  
  // ÖNEMLİ: Sadece bizim eklediğimiz ID'li resmi bulur, faturanın orijinal logosuna dokunmaz
  const logoRegex = /<img[^>]*id="user-added-logo"[^>]*src="data:image\/[^"]*"[^>]*>/i;
  const match = xsltText.value.match(logoRegex);
  
  if (!match) {
    alert("Lütfen önce bir logo yükleyin!");
    return;
  }
  
  const logoHtml = match[0];
  let updatedXslt = xsltText.value;
  
  // Alanları temizle (İçine boşluk koyarak kapatılmasını engelle)
  const cleanSol = new RegExp(`(<div id="${solId}"[^>]*>)([\\s\\S]*?)(<\\/div>)`, 'i');
  const cleanSag = new RegExp(`(<div id="${sagId}"[^>]*>)([\\s\\S]*?)(<\\/div>)`, 'i');
  updatedXslt = updatedXslt.replace(cleanSol, `$1&#160;$3`).replace(cleanSag, `$1&#160;$3`);
  
  // Logoyu hedef tarafa yerleştir
  const targetId = (targetSide === 'left') ? solId : sagId;
  const fillTarget = new RegExp(`(<div id="${targetId}"[^>]*>)([\\s\\S]*?)(<\\/div>)`, 'i');
  
  xsltText.value = updatedXslt.replace(fillTarget, `$1${logoHtml}$3`);
  
  setTimeout(() => { transform(); }, 150);
};

const transform = () => {
  try {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlText.value, "text/xml");
    const xslDoc = parser.parseFromString(xsltText.value, "text/xml");
    const errorNode = xslDoc.querySelector("parsererror");
    if (errorNode) return;

    const xsltProcessor = new XSLTProcessor();
    xsltProcessor.importStylesheet(xslDoc);
    const resultDoc = xsltProcessor.transformToDocument(xmlDoc);
    previewHtml.value = new XMLSerializer().serializeToString(resultDoc);
  } catch (err) { console.error("Dönüşüm hatası:", err); }
};

// Dosyayı indirirken imza ekler
const downloadXslt = () => {
  if (!xsltText.value) return;
  const signatureKey = 'tool="XSLTDesignTool"';
  let content = xsltText.value;
  if (!content.includes(signatureKey)) {
    content = content.replace('<xsl:stylesheet', `<xsl:stylesheet ${signatureKey}`);
  }
  const blob = new Blob([content], { type: 'text/xml;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName.value || 'tasarim.xslt';
  a.click();
  URL.revokeObjectURL(url);
};
// Dosya seçildiğinde veya bırakıldığında çalışan kontrol merkezi
// Dosya seçildiğinde veya bırakıldığında çalışan kontrol merkezi
const handleXsltFile = (file) => {
  if (!file) return;
  const reader = new FileReader();
  reader.onload = (e) => {
    const content = e.target.result;
    const hasSignature = content.includes('tool="XSLTDesignTool"');

    if (!hasSignature) {
      pendingXsltContent.value = content;
      pendingFileName.value = file.name;
      showWarningModal.value = true;
    } else {
      // Ayarları senkronize et
      syncSettingsFromCode(content);
      applyXslt(content, file.name);
    }
  };
  reader.readAsText(file);
};

const showFloatingEditor = ref(false);
const editorPos = ref({ top: '0px', left: '0px' });
let editorInstance = null;

const closeEditor = () => {
  if (window.tinymce) window.tinymce.remove('#tiny-editor-container');
  showFloatingEditor.value = false;
};

const openTinyEditor = (targetElement, mouseEvent, rect) => {
  showFloatingEditor.value = true;
  const editorWidth = 600;
  const editorHeight = 400;
  let leftPos = mouseEvent.clientX + rect.left;
  if (leftPos + editorWidth > window.innerWidth) leftPos = window.innerWidth - editorWidth - 20;
  let topPos = mouseEvent.clientY + rect.top + 10;
  if (topPos + editorHeight > window.innerHeight) topPos = mouseEvent.clientY + rect.top - editorHeight - 10;
  
  editorPos.value = { top: topPos + 'px', left: Math.max(10, leftPos) + 'px' };
  
  if (window.tinymce) window.tinymce.remove('#tiny-editor-container');

  setTimeout(() => {
    window.tinymce.init({
      selector: '#tiny-editor-container',
      height: 350,
      menubar: false,
      plugins: 'table advlist lists link code charmap emoticons',
      toolbar: 'undo redo | bold italic underline | forecolor backcolor | alignleft aligncenter alignright | table tabledelete | tableprops cellprops | removeformat | bullist',
      // KRİTİK AYARLAR:
  table_grid: true,
  table_appearance_options: true, // Tablo görünüm seçeneklerini açar
  table_advtab: true, // Gelişmiş (Advanced) sekmesini tam aktif eder
  table_cell_advtab: true, // Hücre gelişmiş sekmesini tam aktif eder
      // Tablo renklerini daha rahat seçmek için renk paletini genişletebilirsin
  color_map: [
    "000000", "Siyah",
    "808080", "Gri",
    "FFFFFF", "Beyaz",
    "FF0000", "Kırmızı",
    "FFFF00", "Sarı",
    "008000", "Yeşil",
    "0000FF", "Mavi"
  ],
  setup: (editor) => {
  editorInstance = editor;
  editor.on('init', () => {
    // targetElement'ten (faturadaki onarılmış halden) içeriği çek
    let content = targetElement.innerHTML;
    
    // XSLT etiketlerini ayıkla
    content = content.replace(/<xsl:text[^>]*>|<\/xsl:text>/g, '');

    // Editörün içine basmadan önce son kez decode et (Tablo olduğu anlaşılsın)
    const txt = document.createElement("textarea");
    txt.innerHTML = content;
    let finalContent = txt.value;

    editor.setContent(finalContent);
    editor.focus();
        });
      }
    });
  }, 100);
};

const saveAndCloseEditor = () => {
  if (!editorInstance) return;
  const htmlContent = editorInstance.getContent(); // Editörden gelen canlı HTML
  const targetId = 'editableNoteWrapper';
  
  let updatedXslt = xsltText.value;

  // 1. Karakterleri XML için güvenli hale getiriyoruz (Escape işlemi)
  // Bu işlem <table.. kodunu &lt;table.. yapar. 
  // CDATA kullanmadığımız için bu adım zorunludur.
  const escapedHtml = htmlContent
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  // 2. TD alanını hedefleyen Regex (Senin kodundaki id="tinyNotesTableTd" üzerinden)
  const tdRegex = new RegExp(`(<td[^>]*id="tinyNotesTableTd"[^>]*>)([\\s\\S]*?)(<\\/td>)`, 'i');

  if (updatedXslt.match(tdRegex)) {
    // CDATA'YI SİLDİK! 
    // Bunun yerine içeriği xsl:text içine alıp "disable-output-escaping" diyoruz.
    // Bu sayede Orkestra/Görüntüleyici &lt; gördüğü yeri tabloya çevirecek.
    const finalContent = `$1<div id="${targetId}"><xsl:text disable-output-escaping="yes">${escapedHtml}</xsl:text></div>$3`;
    
    updatedXslt = updatedXslt.replace(tdRegex, finalContent);
    xsltText.value = updatedXslt;

    // Persist: Değişikliği localStorage'a kaydetmeyi unutma [2026-01-16]
    userTextChanges.value['lastNoteChange'] = htmlContent;
    localStorage.setItem('userTextChanges', JSON.stringify(userTextChanges.value));
  }

  closeEditor();
  
  // Transform ve arkasından injectInteractions gelmeli
  setTimeout(() => { 
    transform(); 
    // Transform biter bitmez injectInteractions'ı tetikle ki tablo "canlansın"
    setTimeout(() => { injectInteractions(); }, 150);
  }, 300);
};

const toggleLogoStyle = () => {
  if (!xsltText.value.includes('id="user-added-logo"')) return;

  // RGBA formatına çevirip hafif bir şeffaflık (0.2) ekliyoruz ki gölge doğal dursun
  const hex = logoShadowColor.value;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const rgba = `rgba(${r}, ${g}, ${b}, 0.2)`;

  const shadowStyle = `border: 1px solid #ddd; box-shadow: 0 4px 8px ${rgba}; padding: 5px; background: #fff;`;

  // Mevcut stili temizle ve yenisini bas
  // Önce varsa eski gölge/çerçeve kodlarını temizliyoruz
  let currentXslt = xsltText.value;
  const oldStyles = [
    /border: 1px solid #ddd; /g,
    /box-shadow: 0 [^;]*; /g,
    /padding: 5px; /g,
    /background: #fff; /g
  ];
  
  oldStyles.forEach(reg => { currentXslt = currentXslt.replace(reg, ""); });

  if (logoShadowEnabled.value) {
    // Yeni stili style tırnağının hemen içine ekle
    xsltText.value = currentXslt.replace(
      /(id="user-added-logo"[^>]*style=")/,
      `$1${shadowStyle} `
    );
  } else {
    xsltText.value = currentXslt;
  }
  
  setTimeout(() => { transform(); }, 50);
};

const loadPresetTemplate = async (event) => {
  const path = event.target.value;
  if (!path) return;

  const currentXslt = xsltText.value;
  
  // 1. Yedeklemeler: Logo, Notlar, Arka Plan Stili, Font Ayarları
  const logoMatch = currentXslt.match(/<img[^>]*id="user-added-logo"[^>]*>/i);
  const notesMatch = currentXslt.match(/<div id="editableNoteWrapper">([\s\S]*?)<\/div>/i);
  const bgStyleMatch = currentXslt.match(/<style id="bg-style">[\s\S]*?<\/style>/i);
  
  // Font ayarlarını sakla - YENİ EKLENDİ
  const fontColorStyle = currentXslt.match(/<style id="dynamic-font-color">[\s\S]*?<\/style>/i);
  const fontFamilyStyle = currentXslt.match(/<style id="dynamic-font-family-style">[\s\S]*?<\/style>/i);
  
  const isCurrentlyOnLeft = currentXslt.includes('id="logo-sol-alan"') && 
                            new RegExp('<div id="logo-sol-alan"[^>]*>\\s*<img', 'i').test(currentXslt);

  try {
    const response = await fetch(path);
    if (!response.ok) throw new Error('Şablon dosyası bulunamadı');
    
    let newText = await response.text();

    // --- 2. METİN DEĞİŞİKLİKLERİNİ GİYDİR ---
    if (userTextChanges.value) {
      Object.keys(userTextChanges.value).forEach(oldVal => {
        const newVal = userTextChanges.value[oldVal];
        if (oldVal && newVal) {
          const escapedOldVal = oldVal.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const regex = new RegExp(escapedOldVal, 'g');
          newText = newText.replace(regex, newVal);
        }
      });
    }

    // --- 3. FONT AYARLARINI ENJEKSİYONU (ÖNCEKİ AYARLARI KORU) ---
    let dynamicStyles = '';
    
    // Font rengi: Mevcut ayar varsa onu kullan, yoksa varsayılanı kullan
    if (fontColorStyle) {
      dynamicStyles += fontColorStyle[0] + '\n';
    } else {
      dynamicStyles += `<style id="dynamic-font-color">#mainbody { color: ${fontColor.value} !important; }</style>\n`;
    }
    
    // Font ailesi: Mevcut ayar varsa onu kullan, yoksa varsayılanı kullan
    if (fontFamilyStyle) {
      dynamicStyles += fontFamilyStyle[0] + '\n';
    } else {
      dynamicStyles += `<style id="dynamic-font-family-style">#mainbody { font-family: ${selectedFont.value} !important; }</style>\n`;
    }
    
    // Stil enjeksiyonu yaparken gereksiz tekrarları önle
    newText = newText.replace(/<style id="dynamic-font-color">[\s\S]*?<\/style>/gi, '');
    newText = newText.replace(/<style id="dynamic-font-family-style">[\s\S]*?<\/style>/gi, '');
    
    if (newText.includes('</head>')) {
      newText = newText.replace('</head>', dynamicStyles + '</head>');
    } else {
      newText = newText.replace(/(<xsl:template[^>]*>)/i, `$1${dynamicStyles}`);
    }

    // --- 4. TEMA RENGİNİ KORU (Regex ile şablon renklerini değiştir) ---
    if (themeColor.value) {
      newText = newText.replace(/#ef4444/g, themeColor.value); 
      newText = newText.replace(/#3b82f6/g, themeColor.value);
    }

    // --- 5. NOTLARI VE LOGOYU GERİ YÜKLE ---
    if (notesMatch) {
      const notesRegex = /<td[^>]*id="tinyNotesTableTd"[^>]*>([\s\S]*?)<\/td>/i;
      newText = newText.replace(notesRegex, `<td id="tinyNotesTableTd"><div id="editableNoteWrapper">${notesMatch[1]}</div></td>`);
    }

    if (logoMatch) {
      const targetDivId = isCurrentlyOnLeft ? 'logo-sol-alan' : 'fatura-logosu-alani';
      const logoDivRegex = new RegExp(`(<div id="${targetDivId}"[^>]*>)([\\s\\S]*?)(<\\/div>)`, 'i');
      newText = newText.replace(logoDivRegex, `$1${logoMatch[0]}$3`);
    }

    // 6. Arka Plan Logo Stilini Koru
    if (logoAsBackground.value && bgStyleMatch) {
      newText = newText.replace('</head>', bgStyleMatch[0] + '</head>');
    }

    // State güncellemeleri
    xsltText.value = newText;
    const template = presetTemplates.value.find(t => t.path === path);
    if (template) fileName.value = template.name;
    templatePath.value = path; // Reset işlemi için yolu sakla
    
    // Ayarları senkronize et (Font rengi burada da yakalanacak)
    syncSettingsFromCode(newText);
    
    setTimeout(() => { 
      if (typeof applyTheme === 'function') applyTheme(); 
      transform(); 
    }, 150);

  } catch (err) {
    console.error("Şablon yükleme hatası:", err);
  }
};

// "Varsayılan Şablonla Başla" butonu için fonksiyon
const loadInitialTemplate = () => {
  // Buradaki path'i projenizdeki ana şablonun ismiyle değiştirin
  const defaultPath = '/templates/general.xslt'; 
  
  // select elementini taklit ederek mevcut loadPresetTemplate'i kullanıyoruz
  const mockEvent = { target: { value: defaultPath } };
  loadPresetTemplate(mockEvent);
};

// Yeni bir snapshot (versiyon) kaydet
const saveSnapshot = (note = "") => {
  if (!xsltText.value) return;

  // 10 Versiyon Sınırı Kontrolü (Modalı tetikler)
  if (history.value.length >= 10) {
    showLimitModal.value = true;
    return;
  }

  if (!note || note.trim() === "") {
    alert("Lütfen bu versiyon için kısa bir açıklama notu giriniz!");
    return;
  }

  if (history.value.length > 0 && history.value[history.value.length - 1].content === xsltText.value) {
    alert("Mevcut hali zaten son versiyon ile aynı.");
    return;
  }

  const newSnapshot = {
    id: Date.now(),
    timestamp: new Date().toLocaleString('tr-TR'),
    content: xsltText.value,
    note: note.trim()
  };

  history.value.push(newSnapshot);
  historyIndex.value = history.value.length - 1;

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(history.value));
    versionNote.value = ""; 
  } catch (e) {
    alert("Tarayıcı hafızası doldu!");
  }
};

// Silme butonuna basıldığında modalı açar
const deleteVersion = (index) => {
  itemToDelete.value = index;
  showDeleteModal.value = true;
};

// Modalda "Evet" denilirse asıl silme işlemini yapar
const confirmDelete = () => {
  const index = itemToDelete.value;
  if (index === null) return;

  history.value.splice(index, 1);
  
  if (history.value.length === 0) {
    historyIndex.value = -1;
  } else {
    historyIndex.value = history.value.length - 1;
    xsltText.value = history.value[historyIndex.value].content;
    transform();
  }
  
  localStorage.setItem(STORAGE_KEY, JSON.stringify(history.value));
  showDeleteModal.value = false;
  itemToDelete.value = null;
};

const reapplyLogoEffect = () => {
  if (!xsltText.value) return;

  // XSLT içindeki mevcut logoyu cımbızla çek
  const logoMatch = xsltText.value.match(/id="user-added-logo"[^>]*src="(data:image\/[^"]*)"/i);
  
  if (logoMatch && logoMatch[1]) {
    const currentBase64 = logoMatch[1];
    let text = xsltText.value;

    // Önceki stil bloğunu temizle
    text = text.replace(/<style id="bg-style">[\s\S]*?<\/style>/i, "");

    if (logoAsBackground.value) {
      const cssRule = `\n<style id="bg-style">
        #lineTable { 
          position: relative !important; 
          z-index: 1 !important; 
        }
        #lineTable::before {
          content: "" !important;
          position: absolute !important;
          top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important;
          background-image: url('${currentBase64}') !important;
          background-repeat: no-repeat !important;
          background-position: center center !important;
          background-size: 40% !important;
          opacity: 0.2 !important; /* Flu görünüm (0.1 = %10 görünürlük) */
          z-index: -1 !important;
        }
        #lineTable tr, #lineTable td { 
          background-color: transparent !important; 
        }
      </style>\n`;
      
      if (text.includes('</head>')) {
        text = text.replace('</head>', cssRule + '</head>');
      } else {
        text = text.replace('<body>', '<body>' + cssRule);
      }
    }

    xsltText.value = text;
    setTimeout(() => { transform(); }, 150);
  } else if (logoAsBackground.value) {
    logoAsBackground.value = false;
    alert("Lütfen önce bir logo yükleyin!");
  }
};

// Belirli bir versiyona geri dönen fonksiyon
const restoreVersion = (index) => {
  if (index === historyIndex.value) return;

  if (confirm('Bu versiyona dönmek istediğinize emin misiniz? Mevcut düzenlemeleriniz kaybolabilir.')) {
    const targetContent = history.value[index].content;
    
    // 1. Ana kod metnini değiştir
    xsltText.value = targetContent;
    
    // 2. Aktif index'i güncelle
    historyIndex.value = index;
    
    // 3. UI seçimlerini (logo gölgesi, arka plan, font ayarları vb.) kodla eşitle
    syncSettingsFromCode(targetContent);
    
    // 4. Faturayı yeniden oluştur
    transform();
  }
};

// --- TABLO BOYAMA METODU ---
// --- TABLO BOYAMA METODU ---
const applyTheme = () => {
  if (!xsltText.value) return;

  const color = themeColor.value;
  let text = xsltText.value;

  // Eski tema stilini temizle
  text = text.replace(/<style[^>]*id="theme-style"[^>]*>[\s\S]*?<\/style>/gi, "");

  // Yeni CSS kuralı: Arka plan beyaz kalacak şekilde düzenlendi
  const themeStyle = `\n<style id="theme-style">
    /* Fatura dış zeminini beyaz tutuyoruz */
    #mainbody {
      background-color: #ffffff !important;
    }

    /* Tablo genel çerçevesi ve çizgileri */
    #mainbody #lineTable { 
      border: 2px solid ${color} !important; 
    }
    #mainbody #lineTable td.lineTableTd { 
      border: 1px solid ${color}; 
    }

    /* BAŞLIK SATIRI BOYAMA (activeRow) */
    #mainbody tr.activeRow,
    #mainbody tr.activeRow td,
    #mainbody tr.activeRow td.lineTableTd { 
      background-color: ${color} !important; 
      color: #ffffff !important;
      -webkit-print-color-adjust: exact;
    }

    /* Başlık içindeki metinleri (span vb.) beyaza zorla */
    #mainbody tr.activeRow td.lineTableTd * {
      color: #ffffff !important;
      background-color: transparent !important;
    }

    /* Başlık dikey çizgilerini beyaz yap */
    #mainbody tr.activeRow td.lineTableTd {
      
    }
  </style>\n`;

  // XSLT'ye enjekte et - Birden fazla yere ekleyebiliriz
  if (text.includes('</head>')) {
    text = text.replace('</head>', themeStyle + '</head>');
  } else if (text.includes('</xsl:template>')) {
    text = text.replace('</xsl:template>', themeStyle + '</xsl:template>');
  } else {
    text = text.replace(/(<xsl:template[^>]*>)/i, `$1${themeStyle}`);
  }

  xsltText.value = text;
  
  setTimeout(() => { transform(); }, 100);
};

const resetTextChanges = async () => {
  if (confirm("Tüm metin değişiklikleri silinecek ve orijinal şablona dönülecek. Emin misiniz?")) {
    // 1. Hafızayı tamamen sıfırla
    userTextChanges.value = {};
    localStorage.removeItem('userTextChanges');

    // 2. Şablon yolunu templatePath.value'dan al (daha güvenli)
    let currentPath = templatePath.value;
    
    // Eğer templatePath yoksa select'ten al
    if (!currentPath) {
      const templateSelect = document.querySelector('select.preset-select');
      currentPath = templateSelect ? templateSelect.value : null;
    }
    
    // Eğer hala yoksa varsayılan şablonu kullan
    if (!currentPath || currentPath === "") {
      currentPath = '/templates/general.xslt';
      console.log('Şablon yolu bulunamadı, varsayılan şablon yükleniyor:', currentPath);
    }

    try {
      // 3. Orijinal şablonu yeniden yükle (cache önleme)
      const response = await fetch(`${currentPath}?_reset=${Date.now()}`);
      
      if (!response.ok) {
        throw new Error(`Şablon yüklenemedi (HTTP ${response.status}). Yol: ${currentPath}`);
      }
      
      const originalXslt = await response.text();
      
      // 4. MEVCUT LOGO VE NOTLARI KORU
      const currentXslt = xsltText.value;
      
      // Logo'yu koru
      const logoMatch = currentXslt.match(/<img[^>]*id="user-added-logo"[^>]*>/i);
      
      // Notları koru (editableNoteWrapper içindeki her şey)
      const notesMatch = currentXslt.match(/<td[^>]*id="tinyNotesTableTd"[^>]*>([\s\S]*?)<\/td>/i);
      
      // Arka plan stilini koru
      const bgStyleMatch = currentXslt.match(/<style id="bg-style">[\s\S]*?<\/style>/i);
      
      // Font ayarlarını koru
      const fontColorStyle = currentXslt.match(/<style id="dynamic-font-color">[\s\S]*?<\/style>/i);
      const fontFamilyStyle = currentXslt.match(/<style id="dynamic-font-family-style">[\s\S]*?<\/style>/i);
      const themeStyle = currentXslt.match(/<style id="theme-style">[\s\S]*?<\/style>/i);
      
      // Logonun hangi tarafta olduğunu kontrol et
      const isCurrentlyOnLeft = currentXslt.includes('id="logo-sol-alan"') && 
                               new RegExp('<div id="logo-sol-alan"[^>]*>\\s*<img', 'i').test(currentXslt);
      
      // 5. Yeni şablonu oluştur
      let newText = originalXslt;
      
      // 6. Tema rengini uygula (eğer varsa)
      if (themeColor.value) {
        newText = newText.replace(/#ef4444/g, themeColor.value);
        newText = newText.replace(/#3b82f6/g, themeColor.value);
      }
      
      // 7. Font ayarlarını geri yükle
      let dynamicStyles = '';
      
      if (fontColorStyle) {
        dynamicStyles += fontColorStyle[0] + '\n';
      } else {
        dynamicStyles += `<style id="dynamic-font-color">#mainbody { color: ${fontColor.value} !important; }</style>\n`;
      }
      
      if (fontFamilyStyle) {
        dynamicStyles += fontFamilyStyle[0] + '\n';
      } else {
        dynamicStyles += `<style id="dynamic-font-family-style">#mainbody { font-family: ${selectedFont.value} !important; }</style>\n`;
      }
      
      if (themeStyle) {
        dynamicStyles += themeStyle[0] + '\n';
      }
      
      // Stilleri temizle ve yeniden ekle
      newText = newText.replace(/<style id="dynamic-font-color">[\s\S]*?<\/style>/gi, '');
      newText = newText.replace(/<style id="dynamic-font-family-style">[\s\S]*?<\/style>/gi, '');
      newText = newText.replace(/<style id="theme-style">[\s\S]*?<\/style>/gi, '');
      
      if (newText.includes('</head>')) {
        newText = newText.replace('</head>', dynamicStyles + '</head>');
      } else {
        newText = newText.replace(/(<xsl:template[^>]*>)/i, `$1${dynamicStyles}`);
      }
      
      // 8. LOGOYU GERİ YÜKLE
      if (logoMatch) {
        const targetDivId = isCurrentlyOnLeft ? 'logo-sol-alan' : 'fatura-logosu-alani';
        const logoDivRegex = new RegExp(`(<div id="${targetDivId}"[^>]*>)([\\s\\S]*?)(<\\/div>)`, 'i');
        
        // Önce hedef div'i temizle
        newText = newText.replace(logoDivRegex, `$1&#160;$3`);
        
        // Sonra logoyu yerleştir
        const fillTarget = new RegExp(`(<div id="${targetDivId}"[^>]*>)([\\s\\S]*?)(<\\/div>)`, 'i');
        newText = newText.replace(fillTarget, `$1${logoMatch[0]}$3`);
      }
      
      // 9. NOTLARI GERİ YÜKLE
      if (notesMatch) {
        const notesRegex = /<td[^>]*id="tinyNotesTableTd"[^>]*>([\s\S]*?)<\/td>/i;
        newText = newText.replace(notesRegex, notesMatch[0]);
      }
      
      // 10. ARKA PLAN STİLİNİ GERİ YÜKLE
      if (logoAsBackground.value && bgStyleMatch) {
        if (newText.includes('</head>')) {
          newText = newText.replace('</head>', bgStyleMatch[0] + '</head>');
        } else {
          newText = newText.replace(/(<xsl:template[^>]*>)/i, `$1${bgStyleMatch[0]}`);
        }
      }
      
      // 11. XSLT metnini güncelle
      xsltText.value = newText;
      
      // 12. Vue'nun DOM'u güncellemesini bekle
      await nextTick();
      
      // 13. Ayarları senkronize et
      syncSettingsFromCode(newText);
      
      // 14. Önizlemeyi yeniden oluştur
      transform();
      
      // 15. Tema ve font ayarlarını yeniden uygula (gerekirse)
      setTimeout(() => {
        if (typeof applyTheme === 'function') applyTheme();
        if (typeof applyFontFamily === 'function') applyFontFamily();
        if (typeof applyFontColor === 'function') applyFontColor();
      }, 100);
      
      // 16. Kullanıcıya geri bildirim
      alert("Metin değişiklikleri başarıyla sıfırlandı!");
      console.log("Metin değişiklikleri sıfırlandı, orijinal şablona dönüldü.");
      
    } catch (error) {
      console.error("Sıfırlama hatası:", error);
      alert(`Şablon yüklenirken hata oluştu:\n\n${error.message}\n\nŞablon yolu: ${currentPath}\n\nLütfen şablon dosyasının doğru konumda olduğundan emin olun.`);
    }
  }
};

const applyFontColor = () => {
  let content = xsltText.value;
  const colorValue = fontColor.value;

  // Eski font rengi stilini temizle
  content = content.replace(/<style[^>]*id="dynamic-font-color"[^>]*>[\s\S]*?<\/style>/gi, "");

  // Yeni stil bloğu oluştur
  const styleTag = `\n<style id="dynamic-font-color">#mainbody { color: ${colorValue} !important; }</style>\n`;
  
  // XSLT'ye enjekte et
  if (content.includes('</head>')) {
    content = content.replace('</head>', styleTag + '</head>');
  } else if (content.includes('</xsl:template>')) {
    content = content.replace('</xsl:template>', styleTag + '</xsl:template>');
  } else {
    content = content.replace(/(<xsl:template[^>]*>)/i, `$1${styleTag}`);
  }

  xsltText.value = content;
  transform();
};
</script>

<style scoped>
/* Mevcut stillerini buraya yapıştırabilirsin, bir değişiklik gerekmiyor */
.app-container { display: flex; flex-direction: column; height: 100vh; background: #f1f5f9; font-family: 'Inter', sans-serif; }
header { background: #1e293b; color: white; padding: 15px 20px; }
.header-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
.dropzone { border: 2px dashed #475569; border-radius: 8px; padding: 12px; background: #0f172a; cursor: pointer; width: 280px; text-align: center; font-size: 13px; }
.dropzone-active { border-color: #3b82f6; background: #1e293b; }
.quick-edit-bar { background: white; padding: 10px 20px; border-bottom: 1px solid #e2e8f0; display: flex; gap: 20px; align-items: center; flex-wrap: wrap; }
.logo-selector-wrapper { display: flex; align-items: center; gap: 10px; }
.logo-dropzone { border: 1px dashed #cbd5e1; padding: 6px 12px; border-radius: 6px; cursor: pointer; font-size: 12px; background: #f8fafc; }
.logo-active { border-color: #3b82f6; background: #eff6ff; }
.content-wizard { display: flex; align-items: center; gap: 12px; border-left: 2px solid #f1f5f9; padding-left: 15px; }
.wizard-label { font-size: 12px; font-weight: 600; color: #64748b; }
.wizard-group { display: flex; align-items: center; gap: 5px; background: #f8fafc; padding: 4px 8px; border-radius: 8px; border: 1px solid #e2e8f0; }
.small-input { width: 40px; padding: 3px; border: 1px solid #cbd5e1; border-radius: 4px; font-size: 12px; }
.text-input { width: 120px; padding: 3px; border: 1px solid #cbd5e1; border-radius: 4px; font-size: 12px; }
.btn-icon { border: none; background: none; cursor: pointer; font-size: 16px; padding: 4px; border-radius: 4px; transition: 0.2s; }
.btn-icon:hover { background: #e2e8f0; }
.main-content { display: flex; flex: 1; padding: 15px; gap: 15px; overflow: hidden; }
.panel { flex: 1; display: flex; flex-direction: column; background: white; border-radius: 10px; box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1); }
.panel-header { padding: 10px 15px; background: #f8fafc; border-bottom: 1px solid #e2e8f0; font-weight: 600; font-size: 14px; color: #334155; }
textarea { flex: 1; padding: 15px; background: #1e293b; color: #94a3b8; font-family: 'Fira Code', monospace; border: none; outline: none; resize: none; font-size: 12px; }
.preview-iframe { flex: 1; border: none; background: white; }
.btn { padding: 8px 16px; border-radius: 6px; cursor: pointer; border: none; font-weight: 600; font-size: 13px; transition: 0.2s; }
.btn-primary { background: #3b82f6; color: white; }
.btn-secondary { background: #475569; color: white; }
.success { color: #10b981; font-weight: bold; }
.empty-state { display: flex; height: 100%; align-items: center; justify-content: center; color: #94a3b8; }
.tiny-floating-panel { position: fixed; z-index: 9999; background: white; width: 600px; border-radius: 8px; box-shadow: 0 10px 30px rgba(0,0,0,0.3); border: 1px solid #cbd5e1; }
.tiny-panel-header { padding: 8px 12px; background: #f8fafc; display: flex; justify-content: space-between; border-bottom: 1px solid #e2e8f0; }
.save-btn { background: #10b981; color: white; border: none; padding: 6px 15px; border-radius: 4px; cursor: pointer; }
:global(.tox-tinymce-aux) { z-index: 100000 !important; }
:global(.tox-dialog-wrap) { z-index: 100001 !important; }
.preset-select {
  background: #1e293b;
  color: #f1f5f9;
  border: 1px solid #475569;
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 13px;
  outline: none;
  cursor: pointer;
  transition: 0.2s;
}
.preset-select:hover {
  border-color: #3b82f6;
}

/* Hoşgeldin Ekranı Tasarımı */
.welcome-screen {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
}
.welcome-card {
  text-align: center;
  padding: 40px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  border: 1px solid #e2e8f0;
}
.welcome-icon {
  font-size: 60px;
  display: block;
  margin-bottom: 20px;
}
.welcome-card h2 {
  color: #1e293b;
  margin-bottom: 10px;
}
.welcome-card p {
  color: #64748b;
  margin-bottom: 30px;
  line-height: 1.5;
}
.welcome-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.btn-lg {
  padding: 12px 24px;
  font-size: 15px;
  width: 100%;
}
.history-panel {
  background: #fff;
  border-left: 1px solid #e2e8f0;
}

.history-item {
  padding: 10px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.2s;
}

.history-item:hover {
  background: #f8fafc;
}

.history-item.active {
  border-left: 4px solid #3b82f6;
  background: #eff6ff;
}

.history-item-info {
  display: flex;
  flex-direction: column;
}

.history-item-info strong {
  font-size: 12px;
  color: #1e293b;
}

.history-item-info small {
  font-size: 10px;
  color: #64748b;
}

.delete-btn {
  background: none;
  border: none;
  color: #cbd5e1;
  cursor: pointer;
  padding: 5px;
}

.delete-btn:hover {
  color: #ef4444;
}

.modal-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex; align-items: center; justify-content: center;
  z-index: 99999;
}
.modal-card {
  background: white;
  padding: 25px;
  border-radius: 12px;
  width: 350px;
  text-align: center;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.2);
}
.modal-card h3 { margin-top: 0; color: #1e293b; }
.modal-card p { color: #64748b; font-size: 14px; margin: 15px 0; }
.modal-actions { display: flex; gap: 10px; justify-content: center; }

/* BİLGİ BANNER TASARIMI */
.info-banner {
  background: linear-gradient(90deg, #3b82f6, #2563eb);
  color: white;
  padding: 8px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  animation: slideDown 0.5s ease-out;
  border-bottom: 2px solid rgba(255,255,255,0.1);
  z-index: 100;
}

.banner-content {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}

.magic-icon {
  font-size: 18px;
  animation: sparkle 1.5s infinite;
}

/* FARE VE TIKLAMA ANİMASYONU */
.mouse-animation {
  width: 30px;
  height: 30px;
  position: relative;
}

.mouse {
  width: 16px;
  height: 24px;
  border: 2px solid white;
  border-radius: 10px;
  position: relative;
}

.click-wave {
  position: absolute;
  top: 4px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  background: white;
  border-radius: 50%;
  animation: mouseClick 1.2s infinite;
}

/* ANİMASYON KEYFRAMES */
@keyframes slideDown {
  from { transform: translateY(-100%); }
  to { transform: translateY(0); }
}

@keyframes sparkle {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.5; transform: scale(1.2); }
}

@keyframes mouseClick {
  0% { transform: translateX(-50%) scale(1); opacity: 1; }
  50% { transform: translateX(-50%) scale(3); opacity: 0; }
  100% { transform: translateX(-50%) scale(1); opacity: 0; }
}

.close-banner-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  transition: all 0.2s;
  margin-left: 10px;
}

.close-banner-btn:hover {
  background: rgba(255, 255, 255, 0.4);
  transform: scale(1.1);
}

/* Banner'a hafif bir geçiş efekti (Opsiyonel) */
.info-banner {
  /* ... mevcut stiller ... */
  transition: all 0.3s ease;
}

.preset-color-btn {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1px solid rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  padding: 0;
}

.preset-color-btn:hover {
  transform: scale(1.2);
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.preset-color-btn:active {
  transform: scale(0.9);
}

/* Sidebar kapalıyken içeriği ortalar */
.sidebar-closed {
  justify-content: center !important;
}

.sidebar-closed .preview-panel {
  flex: 0 1 1000px !important; /* Önizleme panelinin aşırı büyümesini engeller */
}

/* Küçük açma-kapama butonu stili */
.toggle-sidebar-btn {
  align-self: center;
  background: #3b82f6;
  border: none;
  color: white;
  width: 20px;
  height: 50px;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  z-index: 10;
  transition: background 0.2s;
  margin: 0 -5px; /* Panellerin arasına girmesi için */
}

.toggle-sidebar-btn:hover {
  background: #2563eb;
}

/* Modal Karartma Arkaplanı */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}

/* Modal Kutusu */
.help-modal {
  background: white;
  width: 90%;
  max-width: 500px;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: modalFadeIn 0.3s ease-out;
}

.modal-header {
  padding: 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h2 { margin: 0; font-size: 1.25rem; color: #1e293b; }

.modal-content { padding: 25px; }

/* Kılavuz Maddeleri */
.guide-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  margin-bottom: 20px;
}

.guide-number {
  background: #3b82f6;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-weight: bold;
}

.modal-footer {
  padding: 15px;
  text-align: center;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

@keyframes modalFadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.header-actions {
  display: flex;
  align-items: center;
  /* Butonlar arasına 10px boşluk ekler */
  gap: 10px; 
}

.reset-text-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: #fff;
  color: #dc2626; /* Kırmızı metin */
  border: 1px solid #fca5a5;
  padding: 6px 12px; /* Yüksekliği azaltan ana ayar */
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  height: 32px; /* Net yükseklik belirledik */
  margin-top: 5px;
}

.reset-text-btn:hover {
  background-color: #fef2f2;
  border-color: #dc2626;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.1);
}

.reset-text-btn svg {
  transition: transform 0.4s ease;
}

.reset-text-btn:hover svg {
  transform: rotate(-180deg); /* Üzerine gelince ikon döner */
}

/* Footer ana alanı - Padding değerlerini 30px'den 15px'e düşürdük */
.app-footer {
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
  padding: 15px 20px 10px 20px; /* Üst ve alt boşlukları azalttık */
  color: #64748b;
}

/* İçerik alanı - Gap (boşluk) değerini 50px'den 20px'e düşürdük */
.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center; /* Başlıklar ve linkler aynı hizada olsun */
  gap: 20px; /* Yan yana duran bölümler arası boşluğu kıstık */
  flex-wrap: wrap;
}

/* Başlıkların altındaki boşluğu sıfırladık veya azalttık */
.footer-section h4 {
  color: #1e293b;
  font-size: 13px;
  margin-bottom: 0; /* Alt boşluğu kaldırdık */
  margin-right: 10px; /* Yanındaki metinle arasına küçük bir boşluk koyduk */
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: inline-block;
}

.footer-section p, .footer-links a {
  font-size: 13px;
  text-decoration: none;
  color: #64748b;
  transition: color 0.2s;
}

.footer-links {
  display: flex;
  gap: 20px;
}

.footer-links a:hover {
  color: #3b82f6;
}

/* Ayırıcı çizginin boyunu kısalttık */
.footer-divider {
  width: 1px;
  height: 20px; /* 50px'den 20px'e çektik */
  background: #e2e8f0;
}

/* Alt kısımdaki telif yazısı alanını daralttık */
.footer-bottom {
  margin-top: 10px; /* 30px'den 10px'e düşürdük */
  padding-top: 10px;
  border-top: 1px solid #f1f5f9;
  text-align: center;
}

.support-text {
  color: #10b981;
  font-weight: 600;
}

/* Mobil Uyumluluk */
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 20px;
  }
  .footer-divider {
    display: none;
  }
}

.privacy-modal {
  max-width: 500px; /* Politika metni için daha dar bir görünüm */
}

.privacy-section {
  margin-bottom: 20px;
}

.privacy-section h3 {
  font-size: 16px;
  color: #1e293b;
  margin-bottom: 8px;
}

.privacy-section p {
  font-size: 14px;
  line-height: 1.6;
  color: #64748b;
}

.privacy-note {
  background: #f1f5f9;
  padding: 12px;
  border-radius: 8px;
  text-align: center;
}
.modal-content p {
  margin-bottom: 15px;
  font-size: 14px;
}
.modal-content h2 {
  font-size: 18px;
  margin-bottom: 20px;
  color: #1e293b;
}
</style>